import { CustomSummary } from "../interfaces/OverlineTotals";
import { fetchData } from "../clients/api";
import { handleError } from "../errors";
import { Result } from "./types";

const fetchReportDetailSummaries = async (estimateId: string): Promise<Result<CustomSummary[]>> => {
  try {
    const params: Record<string, string | number | string[]> = {
      search: `report_detail_summaries.estimate;${estimateId}`,
    };
    const response = await fetchData({ table: "report_detail_summaries", params });
    const summaries = response?.data || [];
    return { success: true, data: summaries };
  } catch (error) {
    const err = handleError(error, { table: "report_detail_summaries", context: "fetchReportDetailSummaries" });
    return { success: false, error: err };
  }
};

export { fetchReportDetailSummaries };
